<template>
    <form id="triage-form-preview">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="studentNumber" class="font-weight-bold">Student Number</label>
                    <input v-model="triageData.studentNumber" disabled type="number" class="form-control"
                        id="studentNumber" placeholder="Not Available">
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="mail" class="font-weight-bold">Email address</label>
                    <input v-model="triageData.mail" disabled type="email" class="form-control" id="mail"
                        placeholder="Not Available">
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="firstName" class="font-weight-bold">First Name</label>
                    <input v-model="triageData.firstName" disabled type="text" class="form-control" id="firstName"
                        placeholder="Not Available">
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="lastName" class="font-weight-bold">Last Name</label>
                    <input v-model="triageData.lastName" disabled type="text" class="form-control" id="lastName"
                        placeholder="Not Available">
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="preferredName" class="font-weight-bold">Preferred Name</label>
                    <input v-model="triageData.preferredName" disabled type="text" class="form-control" id="preferredName"
                        placeholder="Not Available">
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="mail" class="font-weight-bold">Home Faculty</label>
                    <select v-model="triageData.homeFaculty" disabled class="form-control" id="homeFaculty">
                        <option value="">Not Available</option>
                        <option value="Kings">King's</option>
                        <option>Western</option>
                        <option>Brescia</option>
                        <option>Huron</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="degree" class="font-weight-bold">Degree</label>
                    <select v-model="triageData.degree" disabled class="form-control" id="degree">
                        <option value="">Not Available</option>
                        <option>Bachelor of Arts</option>
                        <option>Bachelor of Management and Organizational Studies</option>
                        <option>Bachelor of Social Work</option>
                        <option>Second Degree</option>
                        <option>Special Student</option>
                        <option>Not Available</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="yearOfStudy" class="font-weight-bold">Year of Study</label>
                    <select v-model="triageData.yearOfStudy" disabled class="form-control" id="yearOfStudy">
                        <option value="">Not Available</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>Not Available</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="currentModuleCombination" class="font-weight-bold">Current Module Combination</label>
                    <textarea v-model="triageData.currentModuleCombination" disabled class="form-control"
                        id="currentModuleCombination" rows="3" placeholder="Not Available"></textarea>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="desiredModuleCombination" class="font-weight-bold">Desired Module Combination</label>
                    <textarea v-model="triageData.desiredModuleCombination" disabled class="form-control"
                        id="desiredModuleCombination" rows="3" placeholder="Not Available"></textarea>
                </div>
            </div>
            <div class="col-12 col-md-12">
                <div class="form-group">
                    <label for="primaryConcerns" class="font-weight-bold">Primary Concerns</label>
                    <ul>
                        <li v-for="(concerns, index) in triageData.primaryConcerns" :key="index">{{ concerns }}</li>
                    </ul>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="questions" class="font-weight-bold">Questions</label>
                    <div v-if="triageData.questions.length == 0" class="alert alert-primary" role="alert">
                        <i class="fas fa-info-circle"></i> You currently have no questions.
                    </div>
                    <div v-else v-for="(question, index) in triageData.questions" :key="index" class="input-group mb-2">                        
                        <textarea v-model="triageData.questions[index]" class="form-control" disabled
                            :placeholder="'Question ' + (index + 1)" :aria-label="'Question ' + (index + 1)"
                            aria-describedby="Your Questions"></textarea>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="counsellorRequest" class="font-weight-bold">Do you have a specific Advisor/Counsellor
                        that
                        you
                        have worked with previously and would like to see today?</label>
                    <select v-model="triageData.counsellorRequest" disabled class="form-control mb-2"
                        id="counsellorRequest">
                        <option value="">Not Available</option>
                        <option>Yes</option>
                        <option>No</option>
                    </select>
                    <input v-if="triageData.counsellorRequest == 'Yes'" v-model="triageData.counsellor" disabled
                        type="text" class="form-control" id="counsellor" placeholder="None">
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label for="appointmentType" class="font-weight-bold">Appointment Type</label>
                    <select v-model="triageData.appointmentType" class="form-control" disabled id="appointmentType">
                        <option value="">Not Available</option>
                        <option value="inperson">In-person</option>
                        <option value="virtual">Virtual</option>
                    </select>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'triage-form-preview',
    props: {
        triageData: {
            required: true,
            type: Object
        }
    }
}
</script>